module.exports = {
  FETCH_MAIL_CLASSES: 'FETCH_MAIL_CLASSES',
  FETCH_MAIL_CLASSES_SUCCESS: 'FETCH_MAIL_CLASSES_SUCCESS',
  FETCH_MAIL_CLASSES_FAILURE: 'FETCH_MAIL_CLASSES_FAILURE',
  MAIL_CLASS_EXPANDED: 'MAIL_CLASS_EXPANDED',
  MAIL_CLASS_SELECTED: 'MAIL_CLASS_SELECTED',
  ALL_MAIL_CLASSES_SELECTED: 'ALL_MAIL_CLASSES_SELECTED',
  ALL_MAIL_CLASSES_DE_SELECTED: 'ALL_MAIL_CLASSES_DE_SELECTED',
  ALL_CATEGORIES_SELECTED: 'ALL_CATEGORIES_SELECTED',
  ALL_CATEGORIES_DE_SELECTED: 'ALL_CATEGORIES_DE_SELECTED',
  SHOW_ONLY_SELECTED_MAIL_CLASSES: 'SHOW_ONLY_SELECTED_MAIL_CLASSES',
};
